import { render, staticRenderFns } from "./copyright_mobile.vue?vue&type=template&id=2e320a62&"
import script from "./copyright_mobile.vue?vue&type=script&lang=js&"
export * from "./copyright_mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports